import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify, unRestangularize} from 'shared/utils/data-service-utils';
import type {ActionResponse, FacetType} from 'typings/portaro.be.types';

export class FacetTypeDataService {
    public static serviceName = 'facetTypeDataService';

    public static readonly ROUTE = 'facet-types';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getAll(): Promise<FacetType[]> {
        return this.Restangular
            .all(FacetTypeDataService.ROUTE)
            .getList();
    }

    @ngAsync()
    @unRestangularize()
    public async editFacetType(facetType: FacetType): Promise<ActionResponse> {
        return this.Restangular
            .all(FacetTypeDataService.ROUTE)
            .post(transferify({...facetType, confirmed: false}));
    }

    @ngAsync()
    @unRestangularize()
    public async createFacetType(): Promise<ActionResponse> {
        return this.Restangular
            .all(FacetTypeDataService.ROUTE)
            .post({});
    }
}